import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { Disclosure } from '../BetterHelpBanner/styles'

export const Section = styled.div`
  display: flex;
  border-radius: 22px;
  background: ${(props) => (props.lovevery ? '#CCF0E7' : '#1a4c3d')};
  padding: 32px;
  gap: 32px;
  margin-bottom: 16px;
  align-items: center;
  @media (max-width: ${breakpoints.xl}px) {
    padding: 24px;
    gap: 24px;
  }
  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
    gap: 0px;
  }
`

export const FamilyImage = styled.div`
  min-width: 40%;
  @media (max-width: ${breakpoints.l}px) {
    display: none;
  }
`
export const ContentContainer = styled.div`
  @media (max-width: ${breakpoints.l}px) {
    width: 60%;
    margin: auto;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    margin: auto;
  }
`

export const Heading = styled.h2`
  font-family: ${(props) => (props.normal ? 'FilsonPro' : 'FilsonProMedium')};
  color: ${(props) => (props.lovevery ? '#3A3E3D' : '#fffef8')};
  font-size: ${(props) => (props.normal ? '22px' : '28px')};
  line-height: 120%;
  margin: 0px;
  text-align: ${(props) => (props.right ? 'right' : 'left')};
  @media (max-width: ${breakpoints.xl}px) {
    font-size: ${(props) => (props.normal ? '18px' : '22px')};
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    text-align: left;
  }
`
export const Highlight = styled(Heading)`
  color: ${(props) => (props.black ? '#000000' : props.lovevery ? '#00B389' : '#96e093')};
  display: inline-block;
  @media (max-width: ${breakpoints.s}px) {
    font-size: ${(props) => (props.black ? '24px' : '16px')};
  }
`
export const SubHeading = styled.p`
  font-family: 'FilsonProBook';
  line-height: 140%;
  color: ${(props) => (props.lovevery ? '#3A3E3D' : '#fffef8')};
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 14px;
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
    margin-bottom: 24px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
    margin-bottom: 16px;
    text-align: left;
  }
`
export const CtaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: ${breakpoints.s}px) {
    gap: 8px;
  }
`
export const PriceContainer = styled.div`
  text-align: right;
  margin: 8px 0px;
  display: ${(props) => (props.hideOnDesktop ? 'none' : 'block')};
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
    margin: 16px 0px;
    display: ${(props) => (props.hideOnDesktop ? 'flex' : 'flex')};
    justify-content: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    justify-content: center;
    margin-bottom: ${(props) => (props.offerRedeemed ? '0px' : '16px')};
  }
`
export const Strike = styled.span`
  text-decoration: line-through;
`
export const PromotionDetails = styled(Disclosure)`
  margin: 16px 0px 0px;
  text-align: center;
  @media (max-width: ${breakpoints.l}px) {
    span {
      font-size: 14px;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    span {
      font-size: 13px;
    }
  }
`
